import { useState } from "react";
import { type RestaurantWithEventSpaces } from "@/types/restaurant";
import { Skeleton } from "@/components/ui/skeleton";
import { ImagePlaceholder } from "@/components/ui/image-placeholder";

interface RestaurantImageProps {
  restaurant: RestaurantWithEventSpaces;
}

export const RestaurantImage = ({ restaurant }: RestaurantImageProps) => {
  const [hasError, setHasError] = useState(false);

  const handleError = () => {
    setHasError(true);
  };

  return (
    <div className="relative h-44 overflow-hidden">
      {!hasError && restaurant.photos?.[0] ? (
        <img
          src={restaurant.photos[0]}
          alt={restaurant.name}
          className="w-full h-full object-cover"
          loading="lazy"
          onError={handleError}
          sizes="(max-width: 640px) 100vw, (max-width: 1024px) 50vw, 33vw"
        />
      ) : (
        <ImagePlaceholder name={restaurant.name} />
      )}
      {restaurant.eventspaces?.length > 0 && !hasError && (
        <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/60 via-black/40 to-transparent p-3">
          <div className="flex items-center justify-between text-white text-sm">
            <span className="font-medium">
              {restaurant.eventspaces.length} Event Space{restaurant.eventspaces.length !== 1 ? 's' : ''}
            </span>
            <span>
              Up to {Math.max(...restaurant.eventspaces.map(space => parseInt(space.capacity || '0')))} guests
            </span>
          </div>
        </div>
      )}
    </div>
  );
};